//TODO: Move this to App.scss
import 'swiper/css'
import 'swiper/css/free-mode'
import 'react-phone-input-2/lib/style.css'
import './App.scss'
import { Layout } from './components/Layout'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import LoginPage from './components/pages/LoginPage'
import { isLoggedIn } from './api/Session'
import {useMemo, useState} from 'react'
import ForgottenPasswordPage from './components/pages/ForgottenPasswordPage'

var subdomain = "";

function App() {
	let routes

	// const subdomain = useMemo(() => {
	// 	return window.location.host.split('.').reverse()[2]
	// }, [window.location.host])

	// const theme = useMemo(() => {
	// 	return subdomain ? createTheme(subdomain) : defaultTheme
	// }, [subdomain]);

	const [, setLoggedIn] = useState(isLoggedIn())

	const onLoggedIn = (callback?: string | null) => {
		setLoggedIn(isLoggedIn())

		if (callback) {
			window.location.href = callback
		}
	}

	routes = (
		<>
			<Route
				key="login"
				path={'/login'}
				element={isLoggedIn() ? <Navigate to={'/'} /> : <LoginPage onLoggedIn={onLoggedIn} />}
			/>
			,
			<Route
				key="forgotten-password"
				path={'/forgotten-password'}
				element={isLoggedIn() ? <Navigate to={'/'} /> : <ForgottenPasswordPage />}
			/>
			,
			<Route
				key="main"
				path={'/*'}
				element={isLoggedIn() ? <Layout /> : <Navigate to={`/login${window.location.search}`} />}
			/>
		</>
	)

	return (
		<>
			<div className="App">
				<BrowserRouter>
					<Routes>{routes}</Routes>
				</BrowserRouter>
			</div>
		</>
	)
}

export default App
export function getSubdomain() : string {
	return subdomain;
}
